// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\home\\EventsSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103304.8125";
}
// REMIX HMR END

export { EventsSection } from "./EventsSection";
export type { Event } from "./EventsSection";